module.exports = __webpack_public_path__ + "8a5356e9/img/comment-question-icon.7dd26e04.svg";